
  var _styles = {
  "city-select-item-container": {
    "position": "absolute",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "1.17333rem"
  },
  "city-select-item-prefix": {
    "fontSize": "0.42667rem",
    "fontWeight": "500",
    "color": "rgb(0,0,0)"
  }
};



  module.exports = _styles;
  